import { Templates } from "@package/ui-gql/index-data-access";
import { type SliceWallScreenState } from "@package/ui-wall-engine";
import { ScreenLayoutCustom } from "./ScreenLayoutCustom";
import { ScreenLayoutTemplate } from "./ScreenLayoutTemplate";

export type ScreenContentProps = {
  screen: SliceWallScreenState;
};

export function ScreenContent({ screen }: ScreenContentProps) {
  if (screen.layout.template === Templates.Custom) {
    return <ScreenLayoutCustom screen={screen} />;
  }

  return <ScreenLayoutTemplate screen={screen} />;
}
